// extracted by mini-css-extract-plugin
export default {"step1":"Step1_jurisdiction_step1__8fMS+","content":"Step1_jurisdiction_content__Zpoag","gridCards":"Step1_jurisdiction_gridCards__sayw-"};